/**
 * Created by jv on 13/01/2017.
 */
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();

var storageController = {};

(function(StorageController)
{
  StorageController.keys = {
    LOGGED_IN_USER: "logged_in_user",
    ORDER: "order",
    ACTIVE_CARD_GAME: "active_card_game",
    ROUND_TIMERS: "round_timers"
  };

  function shouldEncode(key)
  {
    // Basically obfuscates the data from these keys
    // return $.inArray(key, [ StorageController.keys.LOGGED_IN_USER, StorageController.keys.ORDER, StorageController.keys.ROUND_TIMERS ]) !== -1;
    return [ StorageController.keys.LOGGED_IN_USER, StorageController.keys.ORDER, StorageController.keys.ROUND_TIMERS ].includes(key);
  }

  StorageController.clearAll = function()
  {
    StorageController.clearSession();
    StorageController.clearLocal();
  };

  StorageController.clearSession = function()
  {
    sessionStorage.clear();
  };

  StorageController.clearLocal = function()
  {
    localStorage.clear();
  };

  StorageController.removeFromSession = function(key)
  {
    StorageController.saveToSession(key);
  };

  StorageController.saveToSession = function(key, obj)
  {
    if(storageKeyIsValid(key))
    {
      // if obj is null then remove
      if(utils.isUndefined(obj))
      {
        sessionStorage.removeItem(key);
      }
      else
      {
        if(utils.isObject(obj))
        {
          if(utils.isFunction(obj.getSerializable))
          {
            obj = obj.getSerializable();
          }

          obj = utils.stringifyJSON(obj);
        }

        if(shouldEncode(key))
        {
          obj = utils.btoa(obj);
        }

        sessionStorage.setItem(key, obj);
      }
    }
    else
    {
      console.error("Invalid storage key [%s]", key);
    }
  };

  StorageController.getFromSession = function(key, json)
  {
    if(storageKeyIsValid(key))
    {
      let tmpValue = sessionStorage.getItem(key);

      if(shouldEncode(key))
      {
        try
        {
          tmpValue = utils.atob(tmpValue);
        }
        catch(e)
        {
          log.error("Failed to decode value '%s'", tmpValue);
        }
      }

      if(json)
      {
        return utils.parseJSON(tmpValue, true);
      }

      return tmpValue;
    }
    else
    {
      console.error("Invalid storage key [%s]", key);
    }

    return null;
  };

  StorageController.removeFromLocal = function(key)
  {
    StorageController.saveToLocal(key);
  };

  StorageController.saveToLocal = function(key, obj)
  {
    if(storageKeyIsValid(key))
    {
      if(utils.isUndefined(obj))
      {
        localStorage.removeItem(key);
      }
      else
      {
        if(utils.isObject(obj))
        {
          if(utils.isFunction(obj.getSerializable))
          {
            obj = obj.getSerializable();
          }

          obj = utils.stringifyJSON(obj);
        }

        if(shouldEncode(key))
        {
          obj = utils.btoa(obj);
        }

        localStorage.setItem(key, obj);
      }
    }
    else
    {
      console.error("Invalid storage key [%s]", key);
    }
  };

  StorageController.getFromLocal = function(key, json)
  {
    if(storageKeyIsValid(key))
    {
      let tmpValue = localStorage.getItem(key);

      if(shouldEncode(key))
      {
        try
        {
          tmpValue = utils.atob(tmpValue);
        }
        catch(e)
        {
          log.error("Failed to decode value '%s'", tmpValue);
        }
      }

      if(json)
      {
        return utils.parseJSON(tmpValue, true);
      }

      return tmpValue;
    }
    else
    {
      console.error("Invalid storage key [%s]", key);
    }

    return null;
  };

  function storageKeyIsValid(key)
  {
    for(let objKey in StorageController.keys)
    {
      if(StorageController.keys.hasOwnProperty(objKey) && StorageController.keys[objKey] === key)
      {
        return true;
      }
    }

    return false;
  }

}(storageController));

module.exports = storageController;



// WEBPACK FOOTER //
// ./app/js/controllers/storage-controller.js